var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"contract",staticClass:"w-100",attrs:{"id":"invitation","contentEditable":"false"},domProps:{"innerHTML":_vm._s(_vm.invitation)}})}
var staticRenderFns = []

export { render, staticRenderFns }